import { tickerItems } from "@/mocks/homeContent";

const loopItems = [...tickerItems, ...tickerItems];

export default function TopTicker() {
  return (
    <div className="ticker-shell w-full bg-primary-950 text-background-50">
      <div className="flex items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-primary-600 px-4 py-2 md:px-6">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
          </span>
          <span className="whitespace-nowrap text-xs font-medium tracking-wide md:text-[13px]">
            实时更新条
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center whitespace-nowrap py-2">
            {loopItems.map((item, index) => (
              <span key={`${item.id}-${index}`} className="flex items-center text-xs md:text-[13px]">
                <span className="mx-3 rounded bg-accent-500/25 px-2 py-0.5 font-medium text-accent-200">
                  {item.label}
                </span>
                <span className="text-background-100">{item.text}</span>
                <span className="ml-2 text-background-400">{item.time}</span>
                <span className="mx-4 text-primary-400">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}